export enum MultiChoiceComparison {
  includes = 0,
  doesNotInclude = 1,
  isUpdated = 2,
  isBlank = 3,
  isPresent = 4,
}